import { useCallback, useSyncExternalStore } from 'react';
import { authStore, type Session } from './auth-store';
import { SocketClient } from '../web-socket/socket-client';

/**
 * The session as React state.
 *
 * `useSyncExternalStore` rather than a context + effect because the store is
 * also written from outside React (the magic-link page, and a 401 arriving on
 * the socket), and this is the hook designed for exactly that.
 */
export function useSession(): Session | null {
  return useSyncExternalStore(authStore.subscribe, authStore.get, authStore.get);
}

export function useSignOut(): () => void {
  return useCallback(() => {
    authStore.clear();
    // The socket carries the token in its URL, so a signed-out session has to
    // drop the connection as well as the token — otherwise the old identity
    // keeps receiving queue updates until the server times it out.
    SocketClient.getInstance().disconnect();
  }, []);
}
